import $ from 'jquery'; // Need jQuery because Slick Carousel depends on it.
import isUndefined from 'lodash/isUndefined';
import Carousel from '../../04-components/carousel';
import 'slick-carousel';

class ArticleCarousel extends Carousel {

	constructor(el, options) {
		super(el, options);
	}

	_setup() {

		if (isUndefined(this.options) || isUndefined(this.options.slides)) {
			return false;
        }

		this.config = {
			arrows: true,
			prevArrow: this.el.querySelector('.c-nav-prev'),
			nextArrow: this.el.querySelector('.c-nav-next'),
			dots: true,
			slidesToShow: this.options.slides,
			slidesToScroll: this.options.slides,
			infinite: false,
			responsive: [
				{
					breakpoint: 1024, // without the `px`
					settings: {
						arrows: false,
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 640,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		}

		this.carousel.slick(this.config);
	}
}

export { ArticleCarousel as ArticleCarousel };